var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.591,
    height: 10.396,
    viewBox: "0 0 13.591 10.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5478",
    "data-name": "Rectangle 5478",
    width: 13.591,
    height: 10.396,
    fill: "#7dab3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9591",
    "data-name": "Group 9591",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29898",
    "data-name": "Path 29898",
    d: "M4.073,96.249c0,.386,0,.761,0,1.135,0,.312.215.447.495.31a2.375,2.375,0,0,0,.341-.174.42.42,0,0,1,.517,0c.169.1.354.181.53.273a.374.374,0,0,0,.366,0c.231-.119.463-.237.7-.35a.278.278,0,0,1,.159-.022.307.307,0,0,0,.39-.312c0-.284,0-.568,0-.861h4.063v1.58a2.768,2.768,0,0,0-2.019.445A2.718,2.718,0,0,0,8.574,99.61,2.8,2.8,0,0,0,9.658,102.9c-.055,0-.094.008-.134.008H.7a.638.638,0,0,1-.7-.685q0-2.926,0-5.852c0-.037,0-.074.006-.119Zm.88,4.829c.222,0,.429.007.636,0a.965.965,0,0,0-.034-1.929c-.227,0-.455,0-.682,0s-.26.045-.261.256q0,1.353,0,2.705c0,.033-.012.078,0,.1.047.056.1.135.162.142s.121-.069.163-.123c.024-.03.011-.091.011-.139,0-.331,0-.662,0-1.008m-1.92-1.589-.1.16q-.7,1.123-1.4,2.246a.282.282,0,0,0,.257.464c.464,0,.929,0,1.393,0,.144,0,.235-.072.223-.179-.015-.131-.105-.164-.224-.163-.393,0-.786,0-1.18,0-.04,0-.079-.006-.136-.01.036-.06.061-.1.088-.148q.687-1.1,1.375-2.209a.334.334,0,0,0,.056-.358c-.074-.14-.2-.15-.342-.149-.351,0-.7,0-1.052,0-.128,0-.256,0-.384,0a.169.169,0,0,0,0,.338c.047,0,.095,0,.142,0H3.033m1.155,1.261q0-.662,0-1.323c0-.038,0-.076,0-.114a.169.169,0,0,0-.337-.008.853.853,0,0,0,0,.128q0,1.159,0,2.319c0,.123,0,.247,0,.37,0,.15.06.233.167.236s.173-.08.174-.242c0-.028,0-.057,0-.085v-1.28",
    transform: "translate(0 -92.594)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29899",
    "data-name": "Path 29899",
    d: "M232.587,145.857a2.429,2.429,0,1,1-2.416,2.477,2.435,2.435,0,0,1,2.416-2.477m-.159,2.837a1.286,1.286,0,0,0,1.768-.236,1.263,1.263,0,0,0-1.72-1.812,1.3,1.3,0,0,0-.291,1.811l-1.123,1.124c-.115.115-.129.214-.047.293s.175.059.283-.047.228-.228.342-.342l.788-.791",
    transform: "translate(-221.431 -140.318)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29900",
    "data-name": "Path 29900",
    d: "M6.612,0,6.274,3.294h-4c.018-.049.034-.1.052-.142q.52-1.329,1.04-2.658A.664.664,0,0,1,4.086,0H6.612Z",
    transform: "translate(-2.184 -0.002)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29901",
    "data-name": "Path 29901",
    d: "M194.362,3.3h-4L190.02,0h2.544a.651.651,0,0,1,.7.469q.533,1.355,1.062,2.71c.013.034.023.07.039.121",
    transform: "translate(-182.805 0)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29902",
    "data-name": "Path 29902",
    d: "M119.18.151l.339,3.29H116.74l.339-3.29Z",
    transform: "translate(-112.307 -0.145)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29903",
    "data-name": "Path 29903",
    d: "M116.393,97.339V96.2h2.8v.773c-.14.049-.27.084-.39.139-.2.09-.387.2-.585.287a.281.281,0,0,1-.2,0c-.228-.1-.452-.217-.673-.334a.4.4,0,0,0-.4,0c-.174.094-.353.177-.544.272",
    transform: "translate(-111.974 -92.547)",
    fill: "#7dab3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29904",
    "data-name": "Path 29904",
    d: "M130.636,182.9v-1.223a5.838,5.838,0,0,1,.732.006.615.615,0,0,1-.02,1.212,6.373,6.373,0,0,1-.712.005",
    transform: "translate(-125.676 -174.769)",
    fill: "#7dab3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg4.6105fe65f3f0b5ffdc294305d6d2a59e.svg";
export { ForwardRef as ReactComponent };